import api from './api';

export const getCardsByCustomerApi = (customerId, params) => {
  return api.get(`/cards/customer/${customerId}`, {params});
};

export const getAllCardsByCustomerApi = customerId => {
  return api.get(`/cards/all/customer/${customerId}`);
};

export const getOverusedCardsApi = params => {
  return api.get('/cards/frequent-usage', {params});
};

export const getCardDetailsApi = id => {
  return api.get(`/cards/${id}`);
};

export const addCardApi = async (params) => {
  try {
    const response = await api.post('cards', params);
    if (response.status !== 201) {
      throw new Error(`Unexpected server response. Status: ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error('API Error:', error);
    throw error; 
  }
};

export const editCardApi = params => {
  return api.put('/cards', params);
};

export const reactivateCardApi = customerId => {
  return api.put(`/customers/reactivate/${customerId}`);
};

export const deleteCardApi = cardId => {
  return api.delete(`cards/delete/${cardId}`);
};

export const activateAllCardsApi = customerId => {
  return api.put(`/customers/activateAllCards/${customerId}`);
};

export const deactivateAllCardsApi = customerId => {
  return api.put(`/customers/deactivateAllCards/${customerId}`);
};

export const assingCardsApi = params => {
  return api.put('cards/assign', params);
};

export const getCardsByElevatorApi = (customerId, elevatorId) => {
  return api.get(`cards/all/customer/${customerId}/${elevatorId}`);
};
